<template>
  <div style="
  width: 830px;
  margin: 0px auto;
  padding: 10px 29px;
  background: #eef0f2;
  border: 3px solid #c33c3c96;
  border-radius: 11px;" class="oplatakontragent">
    <div class="row">
      <div class="col-md-6">
        <h4 style="font-weight: bold;color:#3d464c;">
          {{ $t($route.name) }}
          <span v-if="$route.params.id != undefined">№{{ $route.params.id }}</span> <br>
          {{ Dates(datas.datetime) }}
        </h4>
        <button type="button" v-if="$route.params.id!=undefined && settedrule.change==true" @click="Change()"
          class="btn btn-primary change">{{$t('Ўзгартириш')}}</button>
      </div>
      <div class="col-md-6 end" style="padding: 14px 23px;">
        <button type="button" class="mybtn btn saved" @click="Print()" :disabled="changedisabled">
          <b-icon icon="printer"></b-icon> Чек
        </button>
        <button type="button" class="mybtn btn saved" @click="Savedokument()" :disabled="changedisabled">
          {{ $t("Сақлаш ва беркитиш") }} <sup>crl+enter</sup>
        </button>
        <router-link class="btn btn-danger" :to="{ path: '/oplata/index' }">
          <button type="button" class="closebutton">
            <b-icon icon="x-lg"></b-icon>
          </button>
        </router-link>
      </div>
    </div>
    <div class="row">
      <!-- sklad -->
      <!-- <div class="col-md-3"></div> -->
      <div class="col-md-6 topheader">
        <span>
          <label>Склад</label>
          <v-select :clearable="false" class="form-control-sm required md-input" :options="skladlist"
            :disabled="skladhave" v-model="datas.sklad_id" :reduce="name => name.id" label="name">
            <template #search="{ attributes, events }">
              <input class="vs__search" v-bind="attributes" v-on="events" aria-activedescendant="null" />
            </template>
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                <em><b>{{ search }}</b></em>
                {{ $t("бўйича маьлумот йўқ") }}
              </template>
              <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
            </template>
          </v-select>
        </span>
      </div>
      <!-- <div class="col-md-3"></div> -->
      <!-- tip -->
      <!-- <div class="col-md-3"></div> -->
      <div class="col-md-6 topheader">
        <span>
          <label for="">{{ $t("Тури") }}</label>
          <v-select :disabled="changedisabled" :clearable="false" class="form-control-sm" :options="typelist"
            v-model="datas.type" :reduce="name => name.id" label="name" required="true"></v-select>
        </span>
      </div>
      <!-- <div class="col-md-3"></div> -->
      <div class="col-md-6">
        <span class="backblock" style="height: 380px;">
          Контрагент
          <!-- kontragent -->
          <div class="col-md-12 topheader">
            <span>
              <label>Контрагент</label>
              <v-select :disabled="changedisabled" :clearable="false" class="form-control-sm required md-input"
                :options="kontragentlist" v-model="datas.kontragent_id" :reduce="name => name.id" label="name"
                @input="Kontragentchange()">
                <template #list-footer>
                  <li style="text-align: center;font-weight:bold;">
                    f4 {{ $t("умумий рўйхат") }}
                  </li>
                </template>
                <template #search="{ attributes, events }">
                  <input class="vs__search" v-bind="attributes" v-on="events" ref="focused" />
                  <button type="button" class="modallist" v-b-modal.modal-kontragentlist>
                    <b-icon icon="three-dots"></b-icon>
                  </button>
                </template>
                <template v-slot:no-options="{ search, searching }">
                  <template v-if="searching">
                    <em><b>{{ search }}</b></em>
                    {{ $t("бўйича маьлумот йўқ") }}
                    <button type="button" class="pluss" @click="kontragent.name = search" v-b-modal.modal-kontragent>
                      +
                    </button>
                    <b>insert</b>
                  </template>
                  <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
                </template>
              </v-select>
            </span>
          </div>
          <!-- Ostatka -->
          <div class="col-md-12 topheader">
            <span>
              <label>{{ $t("Қолдиқ") }}</label><br>
              <div style="text-align:end!important;">{{datas.current_total_dollar}} <span
                  style="color:green;padding-right: 5px;">$</span>|| <span
                  style="padding-left: 5px;">{{datas.current_total|numFormat3}}</span></div>
            </span>
          </div>
          <!-- tipoplata -->
          <div class="col-md-12 topheader">
            <span>
              <label for="">{{ $t("Тўлов тури") }}</label>
              <v-select :disabled="changedisabled" :clearable="false" @input="ChangeKassasumma()"
                class="form-control-sm required md-input" :options="paytypelist" v-model="datas.pay_type_id"
                :reduce="name => name.id" label="name">
                <template #list-footer>
                  <li style="text-align: center;font-weight:bold;">
                    f4 {{ $t("умумий рўйхат") }}
                  </li>
                </template>
                <template #search="{ attributes, events }">
                  <input class="vs__search" v-bind="attributes" v-on="events" />
                  <button type="button" class="modallist" v-b-modal.modal-paytypelist>
                    <b-icon icon="three-dots"></b-icon>
                  </button>
                </template>
                <template v-slot:no-options="{ search, searching }">
                  <template v-if="searching">
                    <em><b>{{ search }}</b></em>
                    {{ $t("бўйича маьлумот йўқ") }}
                  </template>
                  <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
                </template>
              </v-select>
            </span>
          </div>
          <!-- summa -->
          <div class="col-md-12 topheader">
            <span>
              <label>Сумма</label> <br>
              <!-- <vue-numeric :disabled="changedisabled" v-model="datas.summa" separator="space" class="table-input"
              @change="Summachange()" v-bind:precision="2"> -->
              <div style="text-align:end!important;">{{datas.summa|numFormat}}</div>
              <!-- </vue-numeric> -->
            </span>
          </div>
          <!-- tolov vaqti -->
          <div class="col-md-12 topheader">
            <span>
              <label>{{$t('Тўлов вақти')}}</label>
              <input type="date" v-model="pay_date" @change="Changetime()">
            </span>
          </div>
        </span>
      </div>
      <div class="col-md-6">
        <span class="backblock" style="height: 380px;">
          Касса
          <!-- tipoplata kassa -->
          <div class="col-md-12 topheader">
            <span>
              <label for="">{{ $t("Нахд") }}$</label>
              <vue-numeric @change="ChangeKassasumma()" :disabled="changedisabled" v-model="datas.dollar_summa"
                separator="space" class="table-input" v-bind:precision="2">
              </vue-numeric>
            </span>
          </div>
          <div class="col-md-12 topheader">
            <span>
              <label for="">{{ $t("Нахд") }}</label>
              <vue-numeric @change="ChangeKassasumma()" :disabled="changedisabled" v-model="datas.cash_summa"
                separator="space" class="table-input" v-bind:precision="2">
              </vue-numeric>
            </span>
          </div>
          <!-- kassa summa -->
          <div class="col-md-12 topheader">
            <span>
              <label>Пластик</label>
              <vue-numeric @change="ChangeKassasumma()" :disabled="changedisabled" v-model="datas.plastic_summa"
                separator="space" class="table-input" v-bind:precision="2">
              </vue-numeric>
            </span>
          </div>
          <div class="col-md-12 topheader">
            <span>
              <label>Перечесления</label>
              <vue-numeric @change="ChangeKassasumma()" :disabled="changedisabled" v-model="datas.shot_summa"
                separator="space" class="table-input" v-bind:precision="2">
              </vue-numeric>
            </span>
          </div>
          <div class="row" style="margin: 0!important;">
            <!-- <div class="col-md-12"> -->
          <div class="col-md-6 topheader">
            <span>
              <label>Қайтим</label>
              <vue-numeric  @change="ChangeKassasumma()" :disabled="changedisabled" v-model="datas.qaytim_som"
                separator="space" class="table-input" v-bind:precision="2">
              </vue-numeric>
            </span>
          </div>
          <div class="col-md-6 topheader">
            <span>
              <label>Қайтим $</label>
              <vue-numeric @change="ChangeKassasumma()" :disabled="changedisabled" v-model="datas.qaytim_dollar"
              separator="space" class="table-input" v-bind:precision="2">
            </vue-numeric>
            </span>
          </div>
          </div>
        <!-- </div> -->
        </span>
      </div>
      <div class="row" style="margin: 0!important;">
      </div>
      <!-- komment -->
      <div class="col-md-9 topheader">
        <span>
          <label for="">Комментарий</label>
          <!-- <textarea :disabled="changedisabled" v-model="datas.comment" cols="30" rows="10"></textarea> -->
          <input style="width: 100%;" type="text" :disabled="changedisabled" v-model="datas.comment">
        </span>
      </div>
      <div class="col-md-3 topheader">
        <span>
          <label>Курс</label>
          <input type="text" @input="ChangeKassasumma()" :disabled="changedisabled" v-model="datas.dollar_rate"></span>
      </div>
    </div>
  </div>
  <!-- <div class="col-md-6"> -->
  <!-- </div> -->
  <!-- </div>
  </div> -->
</template>
<script>
  import $ from "jquery";
  import { print } from "../../components/mixins/print.js";
  export default {
    mixins: [print],
    name: "ChiqimForm",
    data() {
      return {
        typelist: [
          { id: false, name: this.$t("Расход") },
          { id: true, name: this.$t("Кирим") }
        ],
        sklad: "",
        paytype: "",
        kontragent: "",
        skladlist: [],
        paytypelist: [],
        pay_date: 0,
        kontragentlist: []
      };
    },
    props: ["datas"],
    created() {
      let self = this;
      self.$root.$refs.oplata = self;
      self.$root.$on("skladone", function (getdata) {
        self.sklad = getdata;
      });
      self.$root.$on("skladall", function (getdata) {
        self.skladlist = getdata;
      });
      self.$root.$on("paytypeone", function (getdata) {
        self.paytype = getdata;
      });
      self.$root.$on("paytypeall", function (getdata) {
        self.paytypelist = getdata;
      });
      self.$root.$on("kontragentone", function (getdata) {
        self.kontragent = getdata;
      });
      self.$root.$on("kontragentall", function (getdata) {
        self.kontragentlist = getdata;
      });
    },
    mounted: function () {
      let self = this;
      self.Focus();
      self.SetRule('/oplata/index');
    },
    methods: {
      Changetime() {
        let self = this;
        if (self.datas.kontragent_id > 0) {
          var date = new Date(self.pay_date).valueOf().toString().slice(0, 10);
          axios
            .get("api/v1/kontragent/update/payment/id/" + self.datas.kontragent_id + "/date/" + date)
            .then(function (response) {
              self.dataall.number = response.data.number;
              self.$store.state.saved = null;
            });
        } else {
          self.pay_date = 0;
          self.$store.state.errors = self.$t("Kontragent tanlamasdan vaqt belgilash mumkin emas");
        }
      },
      Summachange() {
        if (this.datas.pay_type_id == 3) {
          if (this.datas.pay_type_kassa == 3) {
            this.datas.kassa_summa = this.datas.summa;
          } else {
            this.datas.kassa_summa = this.datas.summa * this.datas.dollar_rate;
          }
        } else {
          if (this.datas.pay_type_kassa != 3) {
            this.datas.kassa_summa = this.datas.summa;
          } else {
            this.datas.kassa_summa = this.datas.summa / this.datas.dollar_rate;
          }
        }
      },
      ChangeKassasumma() {
        if (this.datas.pay_type_id === 3) {
           this.datas.summa = (
                this.datas.cash_summa
                - this.datas.qaytim_som
                + this.datas.plastic_summa + this.datas.shot_summa
            ) / this.datas.dollar_rate +
                + this.datas.dollar_summa
                - this.datas.qaytim_dollar;
        } else {
          this.datas.summa =
                this.datas.cash_summa
                - this.datas.qaytim_som
                + this.datas.plastic_summa + this.datas.shot_summa
                + (this.datas.dollar_summa
                    - this.datas.qaytim_dollar) * this.datas.dollar_rate;
        }
      },
      Kontragentchange() {
        let self = this;
        self.datas.current_total = 0;
        self.datas.current_total_dollar = 0;
        axios({
          method: "get",
          url: "api/v1/kontragent/id/" + self.datas.kontragent_id,
        }).then(function (response) {
          if (response.data.payment_date > 0) {
            self.pay_date = new Date(response.data.payment_date * 1000).toISOString().slice(0, 10);
          }
        });
        axios({
          method: "post",
          url: "api/v1/kontragent/total",
          data: {
            kontragent_id: self.datas.kontragent_id,
            sklad_id: self.datas.sklad_id,
            datetime: self.datas.datetime
          }
        }).then(function (response) {
          response.data.forEach(element => {
            if (element.pay_type_id == 3) {
              self.datas.current_total_dollar = element.total.toFixed(3);
            } else {
              self.datas.current_total += parseFloat(element.total.toFixed(3));
            }
          });
        });
      },
      Focus() {
        this.$refs.focused.focus();
      },
      Selectkontragent(index) {
        this.$root.$emit("tableselect", index);
      },
      Selectpaytype(index) {
        this.$root.$emit("tableselect", index);
      },
      Savedokument() {
        let self = this;
        // if (self.rule.change == true) {
        if (this.$route.path == "/oplata/create") {
          var methods = "post";
          var action = "api/v1/kontragent-pay";
        } else {
          var methods = "patch";
          var action = "api/v1/kontragent-pay/id/" + self.$route.params.id;
        }
        axios({
          method: methods,
          url: action,
          data: self.datas
        }).then(function (response) {
          self.$store.state.saved = null;
          self.$router.push({ name: "Тўлов" });
        });
        // } else {
        //   self.$store.state.errors = self.$t('Sizdan bunday xuquq mavjud emas');
        // }
      },
      Print() {
        let self = this;
        // if (self.rule.change == true) {
        if (this.$route.path == "/oplata/create") {
          var methods = "post";
          var action = "api/v1/kontragent-pay";
        } else {
          var methods = "patch";
          var action = "api/v1/kontragent-pay/id/" + self.$route.params.id;
          localStorage.setItem("print_type", "Копия");
        }
        axios({
          method: methods,
          url: action,
          data: self.datas
        }).then(function (response) {
          let myWindow;
          myWindow = window.open(
            '#/oplata/print/' + response.data.id,
            "_blank",
            "width=1000, height=1000"
          );
          self.$store.state.saved = null;
          self.$router.push({ name: "Тўлов" });
        });
        // } else {
        //   self.$store.state.errors = self.$t('Sizdan bunday xuquq mavjud emas');
        // }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .oplatakontragent .topheader>span {
    border: 2px solid rgb(165, 165, 227);
  }

  .md-dialog .md-dialog-container {
    max-width: 768px;
  }
</style>